import { apiFetch } from "../api";
import { BASE_URL } from "../../commonUrls";

const BASE = `${BASE_URL}/notification`;

export async function getNotifications() {
  const res = await apiFetch(BASE);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function getUnreadCount() {
  const res = await apiFetch(`${BASE}/unread-count`);
  if (!res.ok) return 0;
  const data = await res.json();
  return typeof data === "number" ? data : 0;
}

export async function markNotificationRead(id) {
  return apiFetch(`${BASE}/${id}/read`, { method: "POST" });
}

export async function markAllRead() {
  return apiFetch(`${BASE}/read-all`, { method: "POST" });
}

export async function snoozePlannerItem(itemId, preset) {
  return apiFetch(`${BASE_URL}/planner/${itemId}/snooze`, {
    method: "POST",
    body: JSON.stringify({ preset }),
  });
}
